



















import Vue from 'vue';
import { CustomIndexingLookupsHelper } from '@/mixins/customIndexingLookupsHelper';
import MStoreDescriptionButton from '@/components/shared/MStoreDescriptionButton.vue';
import { CustomIndexingLookupModel } from '@/types';

export default Vue.extend({
  components: { MStoreDescriptionButton },
  name: 'CustomIndexingLookups',
  mixins: [CustomIndexingLookupsHelper],
  props: {
    customIndexingLookups: {
      type: Array,
      required: true
    },
    isDisabled: {
      type: Boolean,
      required: true
    },
  },
  methods: {
    onCustomIndexingLookup(this: any, customIndexingLookupButton: CustomIndexingLookupModel) {
      if (this.isDisabled) {
        return;
      } else {
        this.useCustomIndexingLookup(customIndexingLookupButton);
      }
    },             
  },
  beforeDestroy(this: any) {
    this.closeModal();
  }
});
